import type { CustomCellEditorProps } from "ag-grid-react";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";

import type { CellEditorParams } from "@/ui-modules/core/grid/cell-editor-factory.js";
import { isBackspace, isPrintableKey } from "@/ui-modules/core/grid/cells/editors/utils.ts";

import { type Organism } from "../../../../../graphql.js";
import { searchGenomesForSamples } from "../../../../../redux/modules/sample-editing.js";
import { type ReduxDispatch } from "../../../../../redux/redux-utils.js";
import { GenomeSelector } from "../../../../genome-viewer/GenomeSelector.js";
import { TableCell } from "../core/TableCell.js";

export const OrganismCellEditor = (props: CustomCellEditorProps<string> & CellEditorParams) => {
  const { value } = props;
  const dispatch = useDispatch<ReduxDispatch>();
  const isPrintableEditingKey = isPrintableKey(props.eventKey);
  const isBackspaceKey = isBackspace(props.eventKey);

  const [tag, setTag] = useState<Organism>(value);

  const refInput = useRef(null);

  const onChangeListener = (option: Organism) => {
    setTag(option);
    setTimeout(props.stopEditing, 0);
    props.onValueChange(option);
  };

  return (
    <TableCell editor>
      <GenomeSelector
        ref={refInput}
        selectedGenome={tag}
        onSearch={(searchTerm: string) => dispatch(searchGenomesForSamples(searchTerm, props.node.rowIndex))} // send rowIndex to endpoint to check for excluded org_ids
        onSelect={onChangeListener}
        onFocus={(_event) => (isBackspaceKey ? setTag(null) : undefined)}
        selectProps={{
          isClearable: true,
          defaultInputValue: isPrintableEditingKey ? props.eventKey : "",
          openMenuOnFocus: true,
          autoFocus: true,
          onBlur: () => props.stopEditing(),
        }}
      />
    </TableCell>
  );
};
